import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackShowSubsClientInfo } from './tracking';
import { SearchInfo } from './components/SearchInfo';
import { Statistics } from './components/Statistics';
import { RecentlyWatchedOffers } from './components/RecentlyWatchedOffers';
import { AboutClientPromo } from './components/AboutClientPromo';
import { TabError } from './components/TabError';
import { TabLoader } from './components/TabLoader';
import { currentOpenChatIDSelector } from '../../../selectors';
import { userProfileClientInfoForAnalyticsSelector, userProfileStatusSelector } from '../../../selectors/userProfile';
import { ERequestApiStatus } from '../../../types/appState';
import { ETelemetryEvents } from '../../../types/telemetry';
import { useApplicationContext } from '../../../utils/applicationContext';

export const UserCardAboutTab = () => {
  const { telemetry } = useApplicationContext();
  const status = useSelector(userProfileStatusSelector);
  const clientInfoForAnalytics = useSelector(userProfileClientInfoForAnalyticsSelector);
  const chatId = useSelector(currentOpenChatIDSelector);

  const trackedChatIdRef = React.useRef<string | null | undefined>(null);

  React.useEffect(() => {
    if (status !== ERequestApiStatus.Succeed || !clientInfoForAnalytics || trackedChatIdRef.current === chatId) {
      return;
    }

    trackShowSubsClientInfo(clientInfoForAnalytics);

    trackedChatIdRef.current = chatId;
  }, [status, clientInfoForAnalytics, chatId]);

  // Считаем, сколько раз вкладка отрисовалась с данными
  React.useEffect(() => {
    if (status !== ERequestApiStatus.Succeed) {
      return;
    }

    telemetry.increment(ETelemetryEvents.ClientInfoTabShowSuccess);
  }, [status, telemetry]);

  if (status === ERequestApiStatus.Pending) {
    return <TabLoader />;
  }

  if (status === ERequestApiStatus.Failed) {
    return <TabError />;
  }

  return (
    <div data-testid="UserCardAboutTab">
      <SearchInfo />
      <Statistics />
      <RecentlyWatchedOffers />
      <AboutClientPromo />
    </div>
  );
};
